




import { defineComponent } from '@nuxtjs/composition-api';

import { useNostoOtherPage } from '~/diptyqueTheme/composable/nosto/useNostoOtherPage';

export default defineComponent({
  name: 'NostoPage',
  setup() {
    useNostoOtherPage();
  }
});
